import React, { useState } from "react";
import Popup from "./Popup";

import Paystack from "../../assets/icons/paystack.svg";
import PaystackFull from "../../assets/icons/paystack-full.svg";

type PropType = {
  onClose: () => void;
};

const PaymentPop = ({ onClose }: PropType) => {
  const [selectedOption, setSelectedOption] = useState("");
  const handleChange = (e: any) => {
    setSelectedOption(e.target.value);
  };
  return (
    <Popup onClose={onClose} title="Payment Checkout">
      <div className="flex flex-col items-center gap-4 px-5 md:px-20 py-10">
        <div className="text-[#1C1C1C] text-base font-semibold">
          Kindly complete payment to validate trip
        </div>
        <div className="flex flex-col items-center gap-2">
          <div className="text-[#757575] text-sm">Amount</div>
          <div className="text-black text-xl bg-[#FFF5F6] p-5">N 27,500</div>
        </div>

        <div className="font-semibold text-base">Select Payment Method</div>
        <div className="flex flex-col w-full">
          <div className="flex flex-col gap-3 rounded-md py-6 border p-2">
            <div className="flex justify-between items-center">
              <div className="flex gap-4 items-center">
                <input
                  style={{ accentColor: "#307460" }}
                  type="radio"
                  name="payment"
                  value="PAYSTACK"
                  id=""
                  checked={selectedOption === "PAYSTACK"}
                  onChange={handleChange}
                />
                <div className="flex items-center gap-4">
                  <img className="w-7 h-7" src={Paystack} alt="" />
                  <div className="flex flex-col gap-2">
                    <img className="" src={PaystackFull} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className="outline-none h-11 flex items-center text-white justify-center px-10 bg-[#B9000A] w-full mt-5"
          //   onClick={() => setIsModify(true)}
        >
          Proceed
        </button>
      </div>
    </Popup>
  );
};

export default PaymentPop;
